import { render, staticRenderFns } from "./PrivateNumberRecord.vue?vue&type=template&id=66880c0b"
import script from "./PrivateNumberRecord.vue?vue&type=script&lang=js"
export * from "./PrivateNumberRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports